// @ts-ignore
import {parse, stringify} from 'qs';

export function param(parameters: any): string {
    return stringify(parameters, {arrayFormat: 'indices'});
}

export function deparam(search: string, options?: any): any {
    return parse(search, {ignoreQueryPrefix: true, arrayLimit: 200, ...options});
}
